(() => {
  function hydrateVisibleImages(root) {
    root.querySelectorAll('template[data-mw-menu-image]').forEach((template) => {
      const panel = template.closest('.mw-visual-panel');
      if (panel && panel.hidden) return;
      let ancestor = template.parentElement;
      while (ancestor && ancestor !== root) {
        if (ancestor.tagName === 'DETAILS' && !ancestor.open) return;
        ancestor = ancestor.parentElement;
      }
      template.replaceWith(template.content.cloneNode(true));
    });
  }

  function init(scope = document) {
    scope.querySelectorAll('mega-menu').forEach((menu) => {
      if (menu.dataset.mwVisualReady) return;
      menu.dataset.mwVisualReady = 'true';
      const categories = [...menu.querySelectorAll('.mw-visual-category')];
      const panels = [...menu.querySelectorAll('.mw-visual-panel')];
      const show = (category) => {
        categories.forEach((item) => item.classList.toggle('active', item === category));
        panels.forEach((panel) => {
          const active = panel.id === category.dataset.target;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        if (menu.classList.contains('is-active')) hydrateVisibleImages(menu);
      };
      categories.forEach((category) => {
        category.addEventListener('mouseenter', () => show(category));
        category.addEventListener('focusin', () => show(category));
      });
      let previouslyOpen = false;
      const onStateChange = () => {
        const open = menu.classList.contains('is-active');
        if (open && !previouslyOpen && categories.length) show(categories[0]);
        if (open) hydrateVisibleImages(menu);
        previouslyOpen = open;
      };
      new MutationObserver(onStateChange).observe(menu, { attributes: true, attributeFilter: ['class'] });
      onStateChange();
    });

    scope.querySelectorAll('header-drawer').forEach((drawer) => {
      if (drawer.dataset.mwVisualReady) return;
      drawer.dataset.mwVisualReady = 'true';
      const main = drawer.querySelector('details');
      const onStateChange = () => {
        if (main && main.open) hydrateVisibleImages(drawer);
      };
      new MutationObserver(onStateChange).observe(drawer, { subtree: true, attributes: true, attributeFilter: ['open'] });
      onStateChange();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
